import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { Button as a } from "../../shared/button/Button.component.js";
import { ButtonThemeEnum as i } from "../../shared/button/types.js";
import { S as c } from "../../plus-icon-BolIHS6e.js";
import { c as d } from "../../index-C3-ZVs5E.js";
import f from "react";
import '../../assets/AddButton.css';const u = "_addTriggerButton_1brjf_2", g = "_icon_1brjf_9", o = {
  addTriggerButton: u,
  icon: g
}, h = f.forwardRef(({ copy: t, className: r, ...s }, m) => /* @__PURE__ */ n(
  a,
  {
    theme: i.primary,
    className: d(o.addTriggerButton, r),
    ref: m,
    ...s,
    children: [
      /* @__PURE__ */ e(c, { className: o.icon }),
      t
    ]
  }
));
export {
  h as FlowsAddButton
};
